import React from 'react';

import { useConfigs } from 'modules/configs';

import useStyles from './styles';
import { Default } from './variants/Default';
import { Docs } from './variants/Docs';

interface Props {
    container?: () => HTMLElement;
    className?: string;
}

const TopMenu: React.FC<Props> = ({ container, className }) => {
    const { classes, cx } = useStyles();
    const { entrypoint } = useConfigs();
    return (
        <div className={cx(classes.root, className)}>
            {entrypoint === 'docs' && <Docs container={container} />}
            {entrypoint === 'main' && <Default container={container} />}
        </div>
    );
};

export default TopMenu;
